import Model from "./model";

export default new Model({
  resource: "empresa",
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"nombre", default:"-", required: true, type:"text", width: 300},
    {label:"Dirección", nameAttr:"direccion", default:"-", required: false, type:"text", width: 300},
    {label:"Usuarios", nameAttr:"usuarios", default:[], required: true, type:"multiSelect", itemText:"name", model:"userModel", noSearch:true, width: 150},
  ]
});
